module.exports = __webpack_public_path__ + "jab/media/edit-disable.06852231.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/edit-disable.svg
// module id = 508
// module chunks = 0